<td class="p_kosten_perioden__col text-center p_kosten_perioden__col_footer h5">{{ filterCurrency(sumFooter) }}</td>